import { ReactComponent as HomeIcon } from '../assets/home.svg'
import { useAPI } from 'api/client'
import Select from '../SelectField'
import { components as selectComponents } from 'react-select'
import { useModule } from 'context'

/**
 * @typedef {{
 * value: { id: string, name: string, appurl?: string | null},
 * label: string
 * }} ModuleOption
 */

/**
 * @type {import('react-select').StylesConfig<ModuleOption, false>} props */
const moduleSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    background: 'var(--background-blue)',
    borderWidth: '0.5px',
    borderColor: state.isFocused ? 'white' : 'var(--background-blue)',
    boxShadow: state.isFocused ? '0 0 0 1px white' : 'none',
    minHeight: '28px',
    height: '28px',
    cursor: 'pointer',
    '&:hover': { borderColor: 'white' }
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '0.9rem',
    color: 'white'
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '0.9rem',
    color: 'white'
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: 'white',
    padding: '4px',
    '&:hover': { color: 'white' }
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '0.9rem',
    color: 'var(--background-blue)',
    backgroundColor: state.isFocused ? 'rgba(0, 51, 102, 0.1)' : 'white',
    cursor: 'pointer'
  })
}

export const ModuleSelect = () => {
  const { data, error, loading: userLoading } = useAPI('user/current')
  const { loading: moduleLoading, name } = useModule()

  /** @type {ModuleOption[]} */
  const options = data
    ? data.accounts
        // TODO: Review hardcoded 'noAccess'...needs refinement vs account.active
        // https://invision360.atlassian.net/browse/ENG-1838?focusedCommentId=34117
        .filter((account) => account.module.name !== name && account.active && account.role !== 'noAccess')
        .map((account) => ({
          value: account.module,
          label: account.module.name
        }))
    : []

  if (error) {
    console.error('Error fetching user data for module switcher:', error)
    return null
  }

  if (options.length <= 0) return null

  return (
    <Select
      placeholder={name ?? 'Loading...'}
      options={options}
      disabled={moduleLoading || userLoading}
      styles={moduleSelectStyles}
      isSearchable={false}
      components={{ Placeholder }}
      onChange={(option) => {
        const redirect = option?.value?.appurl
        if (!redirect) return
        window.location.href = redirect
      }}
    />
  )
}

/** @param {import('react-select').PlaceholderProps} props */
const Placeholder = (props) => (
  <selectComponents.Placeholder {...props}>
    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <HomeIcon style={{ width: 14, height: 14, flexShrink: 0, fill: 'white', stroke: 'white' }} />
      {props.children}
    </span>
  </selectComponents.Placeholder>
)
